type HashRouterRedirectLocation = Pick<Location, "hash" | "origin" | "pathname" | "search">;

const SCHEDULE_UPDATE_PATH_PATTERN = /^\/subscription\/schedule-update\/[0-9a-f]{24}\/?$/i;

export function getHashRouterPathRedirectUrl({
  location,
  pathPrefixes,
}: {
  location: HashRouterRedirectLocation;
  pathPrefixes: readonly string[];
}) {
  if (location.hash) {
    return null;
  }

  const shouldRedirect = pathPrefixes.some(
    (prefix) => location.pathname === prefix || location.pathname.startsWith(`${prefix}/`),
  );
  if (!shouldRedirect) {
    return null;
  }

  return `${location.origin}/#${location.pathname}${location.search}`;
}

export function getPreReactHashRouterRedirectUrl(location: HashRouterRedirectLocation) {
  const hasMeaningfulHashRoute = location.hash !== "" && location.hash !== "#";
  if (!hasMeaningfulHashRoute && SCHEDULE_UPDATE_PATH_PATTERN.test(location.pathname)) {
    return `${location.origin}/#${location.pathname.replace(/\/$/, "")}${location.search}`;
  }

  if (!location.search) {
    return null;
  }

  const querySeparator = location.hash.includes("?") ? "&" : "?";
  const hashRoute = location.hash === "#" ? "#/" : location.hash || "#/";
  return `${location.origin}${location.pathname}${hashRoute}${querySeparator}${location.search.substring(1)}`;
}

export function getPreReactHashRouterRedirectState(location: HashRouterRedirectLocation) {
  const redirectUrl = getPreReactHashRouterRedirectUrl(location);
  return { redirectUrl, isRedirecting: redirectUrl != null };
}
